// The "רשימה" part of the task dialog.
//
//   a task that HAS a list  its bar and counts, and open / states and columns / remove
//   a task that may get one  "הוספת רשימה", then the type, states and columns — saved
//                            with the task (a new task: in one transaction on the server)
//   an automatic task        nothing: the system raises and closes those by itself
import { useState } from 'react';
import he from '../../i18n/he';
import Button from '../Button';
import Modal from '../Modal';
import { ErrorText } from '../Loader';
import { taskListsApi } from '../../api';
import ListSetup from './ListSetup';
import CopyFromTask from './CopyFromTask';
import DefinitionModal from './DefinitionModal';
import { ListBar, ListCounts, ListRatio } from './ListGlance';
import { definitionOf } from './shapes';

const L = he.lists;

function RemoveListModal({ task, onClose, onRemoved }) {
  const [error, setError] = useState(null);
  const remove = async () => {
    try {
      await taskListsApi.remove(task.id);
      onRemoved();
    } catch (e) {
      setError(e);
    }
  };
  return (
    <Modal title={L.removeTitle} onClose={onClose} onSave={remove} saveLabel={L.remove}>
      <p>{L.removeQuestion(task.list.total)}</p>
      <p className="delete-warning">{he.common.deleteIrreversible}</p>
      {error && <ErrorText error={error} />}
    </Modal>
  );
}

function ExistingList({ task, onOpen, onChanged }) {
  const [defining, setDefining] = useState(false);
  const [removing, setRemoving] = useState(false);
  return (
    <div className="list-summary">
      <ListBar summary={task.list} thin />
      <div className="list-summary-row">
        <ListCounts summary={task.list} />
        <ListRatio summary={task.list} />
      </div>
      <div className="actions">
        <Button small variant="subtle" onClick={onOpen}>{L.open}</Button>
        <Button small variant="ghost" onClick={() => setDefining(true)}>{L.definition}</Button>
        <Button small variant="ghost" onClick={() => setRemoving(true)}>{L.remove}</Button>
      </div>
      {defining && (
        <DefinitionModal taskId={task.id} onClose={() => setDefining(false)} onSaved={() => { setDefining(false); onChanged(); }} />
      )}
      {removing && (
        <RemoveListModal task={task} onClose={() => setRemoving(false)} onRemoved={() => { setRemoving(false); onChanged(); }} />
      )}
    </div>
  );
}

export default function TaskListSection({ task, draft, onDraft, onOpen, onChanged }) {
  const [shape, setShape] = useState(null);
  if (task.source === 'auto') return null;

  if (task.list) {
    return (
      <div className="list-section">
        <h3>{L.section}</h3>
        <ExistingList task={task} onOpen={onOpen} onChanged={onChanged} />
      </div>
    );
  }

  if (!draft) {
    return (
      <div className="list-section">
        <Button small variant="ghost" onClick={() => { setShape('invitees'); onDraft(definitionOf('invitees')); }}>
          {L.add}
        </Button>
      </div>
    );
  }

  return (
    <div className="list-section">
      <h3>
        {L.section}
        <Button small variant="ghost" onClick={() => { setShape(null); onDraft(null); }}>{L.removeShort}</Button>
      </h3>
      <ListSetup
        value={draft}
        onChange={onDraft}
        shape={shape}
        onShape={(k) => { setShape(k); onDraft(definitionOf(k)); }}
        extraShapes={(
          <button type="button" className={`pill${shape === 'copy' ? ' on' : ''}`} onClick={() => setShape('copy')}>
            {L.copy}
          </button>
        )}
        beforeStates={shape === 'copy' && <CopyFromTask taskId={task.id} draft={draft} onDraft={onDraft} />}
      />
    </div>
  );
}
